export function getSaoPauloDayKey(date: Date): string {
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Sao_Paulo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });

  const parts = formatter.formatToParts(date).reduce((acc, part) => {
    if (part.type !== 'literal') {
      acc[part.type] = part.value;
    }
    return acc;
  }, {} as Record<string, string>);

  return `${parts.year}-${parts.month}-${parts.day}`;
}

export function normalizeCounterDayKey(
  rawDate: string | Date | null | undefined,
  referenceDayKey?: string,
): string | null {
  if (!rawDate) {
    return null;
  }

  if (rawDate instanceof Date) {
    return getSaoPauloDayKey(rawDate);
  }

  const normalized = String(rawDate).trim();
  if (!normalized) {
    return null;
  }

  const parseParts = (dateString: string): string | null => {
    const match = dateString.match(/^([0-9]{4})[-/](\d{1,2})[-/](\d{1,2})$/);
    if (match) {
      const [, year, month, day] = match;
      const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), 12));
      const formatted = getSaoPauloDayKey(date);
      return Number.isNaN(date.getTime()) || formatted === 'NaN-NaN-NaN' ? null : formatted;
    }

    const matchLegacy = dateString.match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
    if (matchLegacy) {
      const [, day, month, year] = matchLegacy;
      const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), 12));
      const formatted = getSaoPauloDayKey(date);
      return Number.isNaN(date.getTime()) || formatted === 'NaN-NaN-NaN' ? null : formatted;
    }

    return null;
  };

  const parsed = parseParts(normalized) || parseParts(normalized.replace(/\./g, '/'));
  if (!parsed) {
    return null;
  }

  if (referenceDayKey && parsed !== referenceDayKey) {
    return parsed;
  }

  return parsed;
}
